<template>
  <div class="indexAdminLogin_LoginFooter_class_div" v-if="systemMetaCopyrightData.systemCopyrightState == 1">
    <span v-if="systemMetaCopyrightData.systemCopyrightICP!=''">ICP备案： {{ systemMetaCopyrightData.systemCopyrightICP }}</span>
    <span v-if="systemMetaCopyrightData.systemCopyrightSecurity!=''">公网安备： {{ systemMetaCopyrightData.systemCopyrightSecurity }}</span>
    <span v-if="systemMetaCopyrightData.systemCopyrightDay!=''">© {{ systemMetaCopyrightData.systemCopyrightDay }}</span>
    <span  v-if="systemMetaCopyrightData.systemCopyrightName!=''">
      {{ systemMetaCopyrightData.systemCopyrightName }}
      <!-- <a class="a_name" :href="systemMetaCopyrightData.systemCopyrightWebsite" target="_blank">
        {{ systemMetaCopyrightData.systemCopyrightName }}
      </a> -->
    </span>
  </div>
</template>

<script setup>
import store from '@/configure/store'

// 系统版权数据
const systemMetaCopyrightData = store.state.systemMetaCopyrightData

</script>
